import isSSR from '@calm/web-common/dist/isSSR';
import { v4 as uuid } from 'uuid';

export const TAB_ID_KEY = 'ctid';

export function getOrCreateTabId(): string {
    if (isSSR()) return '';
    let tabId = sessionStorage.getItem(TAB_ID_KEY) ?? '';
    if (!tabId) {
        tabId = uuid();
        sessionStorage.setItem(TAB_ID_KEY, tabId);
    }
    return tabId;
}
